<header>
	<nav class="navbar is-light">
		<div class="container">
			<div class="navbar-end">
				<div class="phone" *ngIf="officeStatus?.answer">
					<p class="has-text-grey-dark">or call for rates...</p>
					<p>
						<a href="tel:{{ officeStatus.phone }}" target="_blank">
							<i class="fas fa-phone"></i>
							{{ officeStatus.phonefancy }}
						</a>
					</p>
				</div>
			</div>
		</div>
	</nav>
</header>